module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_25.ed757ebb.pdf";